/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    FileImportDTO,
    FileImportDTOFromJSON,
    FileImportDTOToJSON,
} from '../models';

export interface DeleteTransactionsRequest {
    fileImportDTO: FileImportDTO;
}

export interface GetFilterTypesRequest {
    importType: string;
}

export interface ImportCardsRequest {
    fileImportDTO: FileImportDTO;
}

export interface ImportTransactionsRequest {
    fileImportDTO: FileImportDTO;
}

export interface UploadFileRequest {
    file?: Blob;
}

/**
 * 
 */
export class FileImportApi extends runtime.BaseAPI {

    /**
     */
    async deleteTransactionsRaw(requestParameters: DeleteTransactionsRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.fileImportDTO === null || requestParameters.fileImportDTO === undefined) {
            throw new runtime.RequiredError('fileImportDTO','Required parameter requestParameters.fileImportDTO was null or undefined when calling deleteTransactions.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/efrikort/client/fileimportdeletetransactions`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FileImportDTOToJSON(requestParameters.fileImportDTO),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteTransactions(fileImportDTO: FileImportDTO, initOverrides?: RequestInit): Promise<void> {
        await this.deleteTransactionsRaw({ fileImportDTO: fileImportDTO }, initOverrides);
    }

    /**
     */
    async getFilesRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<string>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/efrikort/client/files`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async getFiles(initOverrides?: RequestInit): Promise<Array<string>> {
        const response = await this.getFilesRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getFilterTypesRaw(requestParameters: GetFilterTypesRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<string>>> {
        if (requestParameters.importType === null || requestParameters.importType === undefined) {
            throw new runtime.RequiredError('importType','Required parameter requestParameters.importType was null or undefined when calling getFilterTypes.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/efrikort/client/filters/{importType}`.replace(`{${"importType"}}`, encodeURIComponent(String(requestParameters.importType))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async getFilterTypes(importType: string, initOverrides?: RequestInit): Promise<Array<string>> {
        const response = await this.getFilterTypesRaw({ importType: importType }, initOverrides);
        return await response.value();
    }

    /**
     */
    async importCardsRaw(requestParameters: ImportCardsRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.fileImportDTO === null || requestParameters.fileImportDTO === undefined) {
            throw new runtime.RequiredError('fileImportDTO','Required parameter requestParameters.fileImportDTO was null or undefined when calling importCards.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/efrikort/client/fileimportcards`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FileImportDTOToJSON(requestParameters.fileImportDTO),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async importCards(fileImportDTO: FileImportDTO, initOverrides?: RequestInit): Promise<void> {
        await this.importCardsRaw({ fileImportDTO: fileImportDTO }, initOverrides);
    }

    /**
     */
    async importTransactionsRaw(requestParameters: ImportTransactionsRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.fileImportDTO === null || requestParameters.fileImportDTO === undefined) {
            throw new runtime.RequiredError('fileImportDTO','Required parameter requestParameters.fileImportDTO was null or undefined when calling importTransactions.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/efrikort/client/fileimporttransactions`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FileImportDTOToJSON(requestParameters.fileImportDTO),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async importTransactions(fileImportDTO: FileImportDTO, initOverrides?: RequestInit): Promise<void> {
        await this.importTransactionsRaw({ fileImportDTO: fileImportDTO }, initOverrides);
    }

    /**
     */
    async uploadFileRaw(requestParameters: UploadFileRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<string>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters.file !== undefined) {
            formParams.append('file', requestParameters.file as any);
        }

        const response = await this.request({
            path: `/api/efrikort/client/file`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async uploadFile(file?: Blob, initOverrides?: RequestInit): Promise<string> {
        const response = await this.uploadFileRaw({ file: file }, initOverrides);
        return await response.value();
    }

}
